import apiClient from '../apiClient';
import { DELETE_CITY_URL } from '../apiUrl';

const deleteCityApi = Id => {
  return apiClient.delete(DELETE_CITY_URL(Id));
};

export default deleteCityApi;
